<template>
  <v-tooltip bottom :disabled="!isTextTruncated">
    <template v-slot:activator="{ on, attrs }">
      <span 
        v-bind="attrs" 
        v-on="on" 
        class="truncate-text"
        ref="textElement"
      >
        {{ textoFormatado }}
      </span>
    </template>
    <span>{{ textoFormatado }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'SGPTextTooltipComponent',
  props: {
    texto: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isTextTruncated: false
    }
  },
  computed: {
    textoFormatado() {
      if (this.texto === null || this.texto === undefined) return '-';
      return String(this.texto);
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkIfTextTruncated);
    this.$nextTick(() => {
      this.checkIfTextTruncated();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfTextTruncated);
  },
  methods: {
    checkIfTextTruncated() {
      this.$nextTick(() => {
        const element = this.$refs.textElement;
        if (element) {
          this.isTextTruncated = element.scrollWidth > element.clientWidth;
        }
      });
    }
  },
  watch: {
    texto() {
      this.$nextTick(() => {
        this.checkIfTextTruncated();
      });
    }
  }
}
</script>

<style scoped>
.truncate-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;
  cursor: help;
}
</style>
